<!-- CalculatedCell.vue -->
<template>
    <span>{{ calculatedResult }}</span>
  </template>
  
  <script>
  export default {
    name: "CalculatedCell",
    props: {
        formula: String,
        rowIndex: Number,
        colIndex: Number,
        calculateFunction: Function,
        calculationTrigger: Number
    },
    computed: {
        calculatedResult() {
            //console.log('calculatedResult');
            const trigger = this.calculationTrigger;
            //console.log(trigger);
            return this.calculateFunction(this.formula, this.rowIndex, this.colIndex, trigger);
        }
    }
  }
  </script>